"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const locale_1 = require("@kawaui/locale");
const react_1 = require("react");
const package_json_1 = require("../package.json");
const error_handler_1 = __importDefault(require("./components/error-handler"));
const popover_1 = __importDefault(require("./components/popover"));
const trigger_1 = __importDefault(require("./components/trigger"));
const track_1 = __importDefault(require("./contexts/track"));
const widget_1 = require("./styles/widget");
const hooks_1 = require("./utils/hooks");
const machine_1 = require("./utils/machine");
const machineTypes_1 = require("./utils/machineTypes");
const setCurrency = (store, currencySetter) => {
    if (!(store && store.data && store.data.currency_code && currencySetter))
        return;
    currencySetter(store.data.currency_code);
};
const onHover = (status, send) => {
    send(machineTypes_1.MachineTypes.CLOSED);
    switch (status) {
        case provider_1.ResponseCode.EMPTY:
            send(machineTypes_1.MachineTypes.OPEN_EMPTY);
            break;
        case provider_1.ResponseCode.SUCCESS:
        case provider_1.ResponseCode.CREATED:
        case provider_1.ResponseCode.EXPIRED:
        case provider_1.ResponseCode.REOPEN:
        case provider_1.ResponseCode.CLIENT_ERROR:
        case provider_1.ResponseCode.INVALID_CART:
            send(machineTypes_1.MachineTypes.OPEN_CART);
            break;
    }
};
const useEffects = (store, send) => {
    const { setCurrency: currencySetter } = (0, locale_1.useLocale)();
    (0, react_1.useEffect)(() => {
        setCurrency(store, currencySetter);
    }, [store.data && store.data.currency_code]);
    (0, react_1.useEffect)(() => {
        switch (store.status) {
            case provider_1.ResponseCode.FROZEN:
            case provider_1.ResponseCode.REOPEN:
                send(machineTypes_1.MachineTypes.OPEN_ERROR);
                break;
            case provider_1.ResponseCode.EMPTY:
                send(machineTypes_1.MachineTypes.CLOSED);
                break;
        }
    }, [store.status]);
    (0, react_1.useEffect)(() => {
        if (store.newError)
            send(machineTypes_1.MachineTypes.OPEN_ERROR);
    }, [store.newError]);
    (0, react_1.useEffect)(() => {
        if (store.newItem)
            send(machineTypes_1.MachineTypes.OPEN_NEW_ITEM);
    }, [store.newItem]);
    (0, react_1.useEffect)(() => {
        if (store.newLoyalty)
            send(machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY);
    }, [store.newLoyalty]);
};
const defaultRouting = (route) => (window.location.href = route);
const CartWidget = ({ onRouting = defaultRouting, addtoCartCallback, isHardChoice = false, isTransparent = false, track }) => {
    const [state, send] = (0, hooks_1.useMachine)(machine_1.triggerMachine);
    const store = (0, hooks_1.useStore)();
    const { enterHover, leaveHover } = (0, hooks_1.useHover)();
    useEffects(store, send);
    const handleClose = () => {
        send(machineTypes_1.MachineTypes.CLOSED);
    };
    const onMouseLeave = () => {
        leaveHover();
        if (state.value !== machineTypes_1.MachineTypes.CLOSED)
            send(machineTypes_1.MachineTypes.CLOSED);
    };
    const onMouseEnter = () => {
        enterHover(() => state.value !== machineTypes_1.MachineTypes.OPEN_CART && onHover(store.status, send));
    };
    const openError = state.value === machineTypes_1.MachineTypes.OPEN_ERROR;
    return ((0, jsx_runtime_1.jsx)("div", { "data-widget-version": `${package_json_1.name}@${package_json_1.version}`, children: (0, jsx_runtime_1.jsxs)(track_1.default, { track: track, children: [(0, jsx_runtime_1.jsxs)(widget_1.Placeholder, { onMouseLeave: onMouseLeave, children: [(0, jsx_runtime_1.jsx)(popover_1.default, { store: store, state: state, onClose: handleClose, onRouting: onRouting }), (0, jsx_runtime_1.jsx)(trigger_1.default, { data: store.data, transparent: isTransparent, store: store, state: state, send: send, onMouseEnter: onMouseEnter, onRouting: onRouting })] }), (0, jsx_runtime_1.jsx)(error_handler_1.default, { open: openError, isHardChoice: isHardChoice, store: store, onClose: handleClose, onRouting: onRouting, addtoCartCallback: addtoCartCallback })] }) }));
};
exports.default = CartWidget;
